import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const CommentIcon = forwardRef<SVGSVGElement, IconProps>(function CommentIcon(
  { color = '', height = 12, width = 13, ...props },
  ref,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8054 1.05497C8.11957 0.923024 7.21421 0.86722 6 0.86722C3.49485 0.86722 2.41784 1.132 1.8629 1.62527C1.5943 1.86403 1.37147 2.2249 1.21996 2.83089C1.06628 3.44558 1 4.25459 1 5.33334C1 6.74395 1.13202 7.7501 1.44879 8.38372C1.59745 8.68107 1.76603 8.85226 1.9371 8.95409C2.10374 9.05328 2.34981 9.13278 2.75012 9.13278C3.49893 9.13278 4.10313 9.30422 4.58265 9.62911C5.03227 9.93374 5.28947 10.3221 5.45423 10.5814C5.47932 10.6208 5.50226 10.6571 5.52337 10.6904C5.66903 10.9206 5.72784 11.0135 5.8073 11.0848C5.80902 11.0864 5.81072 11.088 5.81246 11.0896C5.83192 11.1082 5.85767 11.1328 6.00015 11.1328C6.14265 11.1328 6.16839 11.1082 6.18783 11.0897C6.18958 11.088 6.19127 11.0864 6.19299 11.0848C6.27245 11.0135 6.33126 10.9206 6.47695 10.6904C6.49805 10.6571 6.52097 10.6209 6.54603 10.5814C6.71078 10.3222 6.96797 9.93378 7.41759 9.62914C7.8971 9.30423 8.50131 9.13278 9.25012 9.13278C9.65663 9.13278 9.90497 9.05424 10.0711 8.9574C10.2398 8.85904 10.4057 8.69377 10.5526 8.40253C10.8674 7.77821 11 6.77493 11 5.33334C11 4.24091 10.9337 3.42533 10.7799 2.80816C10.6283 2.19978 10.4059 1.84252 10.14 1.60821C9.87583 1.37533 9.47872 1.18451 8.8054 1.05497ZM12 5.33334C12 0.888908 10.941 0 6 0C1.059 0 0 0.941335 0 5.33334C0 8.16537 0.500122 10 2.75012 10C3.95255 10 4.31024 10.5712 4.64332 11.1031C4.9335 11.5664 5.20499 12 6.00012 12C6.79531 12 7.0668 11.5665 7.35698 11.1031C7.69004 10.5712 8.04772 10 9.25012 10C11.5001 10 12 8.22225 12 5.33334Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M4.5 5.5C4.5 5.77614 4.27614 6 4 6C3.72386 6 3.5 5.77614 3.5 5.5C3.5 5.22386 3.72386 5 4 5C4.27614 5 4.5 5.22386 4.5 5.5Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M6.5 5.5C6.5 5.77614 6.27614 6 6 6C5.72386 6 5.5 5.77614 5.5 5.5C5.5 5.22386 5.72386 5 6 5C6.27614 5 6.5 5.22386 6.5 5.5Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8.5 5.5C8.5 5.77614 8.27614 6 8 6C7.72386 6 7.5 5.77614 7.5 5.5C7.5 5.22386 7.72386 5 8 5C8.27614 5 8.5 5.22386 8.5 5.5Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
